import getConfig from "next/config"
import { Button, Image } from "antd"
import styles from "@/styles/view-cart.module.scss"

const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain

const EmptyCart = () => (
  <div className={styles['empty-cart']}>
    <div className={styles['empty-cart-main']}>
      <Image src={`${imageDomain}/empty-cart-icon.png`} width="280px" preview={false} />
      <div className={styles['empty-cart-title']}>Your Shopping cart Is Empty! </div>
      <div className={styles['empty-cart-desc']}>Add products to your cart by clicking the &apos;ADD TO CART&apos; button next to the items you would like to purchase. </div>
      <Button type="primary" href="/" className={styles['empty-cart-btn']}>Continue Shopping</Button>
    </div>
  </div>
)

export default EmptyCart
